// Shared, unsmoothed probability histograms; independent of plot display settings.
export const SEPARATION_HELP = '1 minus the largest pairwise histogram overlap with another unit on the same primary channel. Uses 30 shared equal-width bins and normalized counts: 1 = disjoint, 0 = identical profiles. Requires complete amplitudes in consistent units and at least two units.';

export function amplitudeSeparations(clusters) {
  const result = new Map(clusters.map(cluster => [String(cluster.id), null]));
  const groups = new Map();
  clusters.forEach(cluster => {
    if (cluster.primaryChannel == null) return;
    const key = String(cluster.primaryChannel);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(cluster);
  });
  groups.forEach(peers => {
    if (peers.length < 2 || peers.some(c => !c.spikeAmplitudes?.length ||
      c.spikeAmplitudes.length !== c.spikeTimes?.length ||
      c.spikeAmplitudes.some(v => typeof v !== 'number' || !Number.isFinite(v)))) return;
    let low = Infinity, high = -Infinity;
    peers.forEach(c => c.spikeAmplitudes.forEach(v => { low = Math.min(low, v); high = Math.max(high, v); }));
    if (!Number.isFinite(high - low)) return;
    const histograms = peers.map(c => {
      const bins = Array(30).fill(0);
      c.spikeAmplitudes.forEach(v => {
        const bin = high === low ? 0 : Math.min(29, Math.floor((v - low) / (high - low) * 30));
        bins[bin] += 1 / c.spikeAmplitudes.length;
      });
      return bins;
    });
    peers.forEach((c, i) => {
      let overlap = 0;
      histograms.forEach((other, j) => {
        if (i !== j) overlap = Math.max(overlap, other.reduce((sum, p, k) => sum + Math.min(p, histograms[i][k]), 0));
      });
      result.set(String(c.id), Math.max(0, Math.min(1, 1 - overlap)));
    });
  });
  return result;
}
